import { InjectionToken } from '@angular/core';
import { EcConformityProductDocumentsPage, ProductBrand, ProductDocumentsWrapper } from '../../../core/model';
import { Occ } from '../../../core/occ';
import { Converter } from '../../../core/util/converter.service';

export const PRODUCT_DOCUMENT_NORMALIZER = new InjectionToken<Converter<Occ.ProductDocumentsWrapper, ProductDocumentsWrapper>>(
  'ProductDocumentNormalizer'
);

export const CONFORMANCE_EC_SEARCH_NORMALIZER = new InjectionToken<
  Converter<Occ.EcConformityProductDocumentsPage, EcConformityProductDocumentsPage>
>('ConformanceEcSearchNormalizer');

export const CONFORMANCE_EC_BRAND_NORMALIZER = new InjectionToken<Converter<Occ.ProductBrand, ProductBrand>>(
  'ConformanceEcBrandNormalizer'
);
